import { bootstrapStore } from './bootstrap';

bootstrapStore();
